import useCurrency from '../../hooks/useCurrency';
export default function Roi() {
  /* Follows the visitor's detected currency, like every other price. */
  const { symbol, price } = useCurrency();
  return (
    <>
<section className="sect" id="s-roi" style={{paddingTop: '24px'}}>
  <div className="container">
    <h2 className="sect-h2">Like adding a chief of staff<br /><span className="dim">to every team</span></h2>
    <p className="sect-sub">Teams on TeamGrid replace tracking tools, status meetings, and manual reports<br />with one brain — and feel it in the first month.</p>
    <div className="center" style={{marginTop: '28px'}}><a className="btn-primary" href="/register">Get started</a></div>

    <div className="roi-cards">
      <div className="roi-card"><div className="rl">PRODUCTIVITY</div><div className="rv">+32%</div><p>Average lift in deep-focus hours after eight weeks of pattern-guided changes.</p></div>
      <div className="roi-card"><div className="rl">TIME BACK</div><div className="rv">6.2h</div><p>Saved per manager, per week, once AI summaries replace status check-ins.</p></div>
      <div className="roi-card"><div className="rl">EARLY WARNINGS</div><div className="rv">92%</div><p>Of burnout and attrition risks surfaced before they reached a resignation letter.</p></div>
      <div className="roi-card"><div className="rl">PAYBACK</div><div className="rv">&lt;1 mo</div><p>At {symbol}{price('standard')} per seat, most teams cover the cost with the first cancelled status meeting.</p></div>
    </div>
    <p className="roi-note">*Aggregated, anonymized TeamGrid workspace benchmarks, 2026. <a href="/pricing">See pricing →</a></p>
  </div>
</section>
    </>
  );
}
